<div class="wizard-step-content">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <div>
      <h3 class="mb-1">
        <i class="fa fa-handshake text-primary me-2"></i>
        {{ 'eventWizard.sponsors.title' | translate }}
      </h3>
      <p class="text-muted mb-0">{{ 'eventWizard.sponsors.subtitle' | translate }}</p>
    </div>
    <app-button
      [variant]="'primary'"
      [label]="'eventWizard.sponsors.addSponsor' | translate"
      [iconClass]="'fa fa-plus'"
      [disabled]="!event"
      (clicked)="openAddSponsorModal()"
    />
  </div>

  @if (!event) {
    <div class="alert alert-warning">
      <i class="fa fa-exclamation-triangle me-2"></i>
      {{ 'eventWizard.sponsors.completeBasicFirst' | translate }}
    </div>
  } @else if (sponsors.length === 0) {
    <div class="text-center py-10">
      <i class="fa fa-handshake fs-3x text-muted mb-4 d-block opacity-50"></i>
      <h5 class="text-muted mb-2">{{ 'eventWizard.sponsors.noSponsorsYet' | translate }}</h5>
      <p class="text-muted mb-4">{{ 'eventWizard.sponsors.sponsorsOptional' | translate }}</p>
    </div>
  } @else {
    <div class="row g-4">
      @for (sponsor of sponsors; track sponsor.sponsor_id) {
        <div class="col-md-6 col-lg-4">
          <div class="card h-100">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-start mb-3">
                <div class="d-flex align-items-center">
                  @if (sponsor.logo_url) {
                    <img [src]="sponsor.logo_url" alt="{{ sponsor.sponsor_name }}"
                         class="me-3" style="width: 60px; height: 60px; object-fit: contain; border-radius: 8px;">
                  } @else {
                    <div class="symbol symbol-60px me-3">
                      <span class="symbol-label bg-light-primary">
                        <i class="fa fa-building text-primary fs-3"></i>
                      </span>
                    </div>
                  }
                  <div>
                    <h5 class="mb-0">{{ sponsor.sponsor_name }}</h5>
                  </div>
                </div>
                <div class="dropdown">
                  <button
                    class="btn btn-sm btn-icon btn-light"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    <i class="fa fa-ellipsis-v"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li>
                      <a class="dropdown-item" (click)="openEditSponsorModal(sponsor)">
                        <i class="fa fa-edit me-2"></i>{{ 'common.edit' | translate }}
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item text-danger" (click)="deleteSponsor(sponsor)">
                        <i class="fa fa-trash me-2"></i>{{ 'common.delete' | translate }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              @if (sponsor.sponsor_description) {
                <p class="text-muted mb-0">{{ sponsor.sponsor_description }}</p>
              }
            </div>
          </div>
        </div>
      }
    </div>

    <div class="alert alert-light-info border border-info border-dashed mt-4">
      <div class="d-flex align-items-center">
        <i class="fa fa-info-circle text-info fs-2 me-3"></i>
        <div>
          <strong>{{ 'eventWizard.sponsors.sponsorsAdded' | translate:{ count: sponsors.length } }}</strong>
          <div class="text-muted">{{ 'eventWizard.sponsors.continueOrAddMore' | translate }}</div>
        </div>
      </div>
    </div>
  }
</div>
